import '@/static/style/pc.less';

import '@/utils/removeConsole';

import Vue from 'vue';
import App from './App.vue';
import i18n from '@/i18n';

import ajax from '@/utils/ajax';

import ImageViewer from '@/components/ImageViewer/index';
import MessageBox from '@/components/MessageBox/index';
import MediaViewer from '@/components/MediaViewer/index';
import Vue2TouchEvents from 'vue2-touch-events';
import Contextmenu from 'vue-contextmenujs';
import VueClipboard from 'vue-clipboard2';

// import { mockStart } from '@/mock';
// if ('development' === process.env.NODE_ENV) {
//   console.log('🥳 ~ process.env.NODE_ENV:', process.env.NODE_ENV);
//   mockStart();
// }

const ua = navigator.userAgent;
Vue.prototype.$platform = {
  pc: true,
  iOS: /iPhone|iPad|iPod/i.test(ua),
  Android: /Android/i.test(ua),
  Weixin: /MicroMessenger/i.test(ua),
  WeixinApp: /MicroMessenger/i.test(ua) && /miniProgram/i.test(ua),
};

Vue.prototype.$ajax = ajax;

Vue.config.productionTip = false;

Vue.use(ImageViewer);
Vue.use(MessageBox);
Vue.use(MediaViewer);
Vue.use(Vue2TouchEvents);
Vue.use(Contextmenu);
Vue.use(VueClipboard);

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app');
